import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';

import { MSALService } from './msal.service';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { map, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Resolver used for the login route, to retrieve the user login information for the
 * adal service.
 * Example:
 * ```ts
 * { path: 'login', component: LoginComponent, resolve: { user: HandleAdCallbackResolver } }
 * ```
 *
 * @export
 * @class HandleAdCallbackResolver
 */
@Injectable()
export class HandleAdCallbackResolver implements Resolve<adal.User | boolean> {
  constructor(private msalService: MSALService) {}

  resolve(): Observable<adal.User | boolean> {
    return this.adalConfigLoaded().pipe(
      filter(loaded => loaded),
      map(() => {
        this.msalService.handleCallback();
        if (this.msalService.getisAuthenticated()) {
          return this.msalService.getUserAccount();
        }
        return false;
      })
    );
  }

  private adalConfigLoaded(): Observable<boolean> {
    return Configuration.getAsync('adal').pipe(
      map(config => {
        console.log(config);
        return !!config;
      })
    );
  }
}
